<style>
	.profile-img-box {
		margin: auto;
		padding: 1em;
		width: 30em;
		height: 15em;
		border-radius: 10px;
		background: #d5e0ff;
		box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-webkit-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		-moz-box-shadow: 1px 2px 6px 2px rgba(0, 0, 0, 0.31);
		display: flex;
	}

	.input-container {
		font-family: Arial, Helvetica, sans-serif;
		font-size: large;
		margin: auto;
		padding: 5px;
		/* height: 90%;
		width: 90%; */

		display: flex;
		flex-direction: column;
		justify-content: space-around;
		gap: 1em;
		align-items: center;
	}

	.btn {
		color: white;
		background-color: #f24b4b;
		height: 2em;
		text-align: center;
		border-radius: 3px;

		width: 200px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.btn>span {
		font-family: Arial, Helvetica, sans-serif;
		letter-spacing: 1px;
	}

	.username-label {
		text-align: center;
	}

	.img-container {
		padding: 0.5em
	}

	.img-container img {
		width: 3.5em;
		border-radius: 50%;
		border: solid white 3px;
		background-color: white;
		cursor: pointer;
	}
</style>

<script>
	import { onMount } from 'svelte';
	export let uName
	export let uID
	export let nextPart
	let img1
	let img2
	let img3
	let img4

	let selectedImg = '1'

	onMount(() =>
	{
		img1.style.borderColor = 'greenyellow'
	})

	function selectImg(event) {
		let images = [ img1, img2, img3, img4 ]
		images.forEach(img => img.style.borderColor = 'white')
		
		event.target.style.borderColor = 'greenyellow'

		switch (event.target) {
			case img1:
				selectedImg = '1'
				break;
			case img2:
				selectedImg = '2'
				break;
			case img3:
				selectedImg = '3'
				break;
			case img4:
				selectedImg = '4'
				break;
		}
	}

	function submitProfileImg() {
		fetch("https://frozen-savannah-62936.herokuapp.com/login",
			{
				method: "post",
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					username: uName,
					profileImgID: selectedImg
				})
			})
			.then(resp => resp.json())
			.then(respObj =>
			{
				uID = respObj.userID
				nextPart()
			})
	}
</script>

<div class="profile-img-box">
	<div class="input-container">
		<div class="username-label">Select a profile image</div>
		<div class="img-container">
			<img bind:this={img1} on:click={selectImg} src="https://i.imgur.com/C5yBJnA.png" alt="Sun with a face">
			<img bind:this={img2} on:click={selectImg} src="https://i.imgur.com/Q9Z6Wel.png" alt="Rocket">
			<img bind:this={img3} on:click={selectImg} src="https://i.imgur.com/IXHlDsg.png" alt="Face with a cat hood">
			<img bind:this={img4} on:click={selectImg} src="https://i.imgur.com/Z3Kk6mq.png" alt="Cat in a space suit">
		</div>

		<div class="btn" on:click={submitProfileImg}>
			<span>Start</span>
		</div>
	</div>
</div>